import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
// Actions
// import { deleteLecture } from "repository/actions/data/dashboard/lectures";

export default withSnackbar(
  withRouter(function (props) {
    const {
      isOpen,
      setClose,
      cohort,
      user,
      setCohort,
      getCohort,
      bulkDeleteLecture
    } = props;
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteLecture = () => {
      if (user && user != null) {
        setSaveLoading(true);

        bulkDeleteLecture(cohort._id, user.idToken)
          .then((result) => {
            getCohort(cohort._id, user.idToken).then((refreshedCohort) => {
              setClose();
              setSaveLoading(false);
              toast.success(`Lectures delected successfully`);

              setTimeout(()=>{
                window.location.reload();
              }, 1000)

            });
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="⚠️ DELETE ALL LECTURES"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteLecture()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete ALL lectures?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
